import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

import { AccountType } from 'app/accountType/AccountType';
import { Dashboard } from 'app/dashboard/Dashboard';
import { Details } from 'app/details/Details';
import { Settings } from 'app/settings/Settings';
import { IssueInstallationContainer } from 'app/issueInstallation/IssueInstallationContainer';
import { IssueVerificationContainer } from 'app/issueVerification/IssueVerificationContainer';
import { ActivateAssetContainer } from 'app/activateAsset/ActivateAssetContainer';
import { General } from 'app/settings/pages/General';
import { IssueAssetContainer } from 'app/issueAsset/IssueAssetContainer';
import { DesktopDashboardGrid } from 'app/desktopDashboardGrid/DesktopDashboardGrid';
import { DesktopAssetsDetailsContainer } from 'app/desktopAssetsDetails/DesktopAssetsDetailsContainer';
import { DesktopDashboardContainer } from 'app/desktopDashboard/DesktopDashboardContainer';
import { ApproveAssetOwnerContainer } from 'app/approveAssetOwner/ApproveAssetOwnerContainer';
import { DesktopMintTokensContainer } from 'app/desktopMintTokens/DesktopMintTokensContainer';
import { HomeContainer } from 'app/home/HomeContainer';
import { HomeDesktopContainer } from 'app/home/HomeDesktopContainer';

import { AuthorizedRoute } from './AuthorizedRoute';
import { AppRoute } from './AppRoute.enum';

const MobileApp = () => (
  <Switch>
    <Route path={AppRoute.home} exact component={HomeContainer} />
    <Route path={AppRoute.accountType} exact component={AccountType} />
    <AuthorizedRoute path={AppRoute.dashboard} exact component={Dashboard} />
    <AuthorizedRoute path={AppRoute.issueAsset} exact component={IssueAssetContainer} />
    <AuthorizedRoute path={AppRoute.issueInstallation} exact component={IssueInstallationContainer} />
    <AuthorizedRoute path={AppRoute.issueVerification} exact component={IssueVerificationContainer} />
    <AuthorizedRoute path={AppRoute.activateAsset} exact component={ActivateAssetContainer} />
    <AuthorizedRoute path={AppRoute.approveAssetOwner} exact component={ApproveAssetOwnerContainer} />

    <AuthorizedRoute path={AppRoute.details} exact component={Details} />
    <AuthorizedRoute path={AppRoute.settings} exact component={Settings} />
    <AuthorizedRoute path={AppRoute.settingsGeneral} exact component={General} />

    <Redirect to={AppRoute.home} />
  </Switch>
);

const DesktopApp = () => (
  <Switch>
    <Route path={AppRoute.home} exact component={HomeDesktopContainer} />
    <AuthorizedRoute path={AppRoute.dashboard} exact component={DesktopDashboardContainer} isDesktop />
    <AuthorizedRoute path={AppRoute.desktopDashboardGrid} exact component={DesktopDashboardGrid} isDesktop />
    <AuthorizedRoute path={AppRoute.batteriesDetails} exact component={DesktopAssetsDetailsContainer} isDesktop />
    <AuthorizedRoute path={AppRoute.desktopMintTokens} exact component={DesktopMintTokensContainer} isDesktop />
    <Redirect to={AppRoute.home} />
  </Switch>
);

export const AppRoutes = () => {
  return isMobile ? <MobileApp /> : <DesktopApp />;
};
